{
  "main": {
    "title": "Ispezioni CAMO"
  },
  "menu": {
    "plovila": {
      "title": "Aeromobili",
      "description": "Panoramica del numero di voli e delle ore di volo totali"
    },
    "liste": {
      "title": "Liste di partenza",
      "description": "Panoramica delle liste di partenza"
    }
  }
}
